import { createContext, useContext, useState, type ReactNode } from "react";

interface CommunityContextType {
  selectedCommunityId: string | null;
  setSelectedCommunityId: (id: string | null) => void;
}

const CommunityContext = createContext<CommunityContextType | undefined>(
  undefined,
);

export function CommunityProvider({ children }: { children: ReactNode }) {
  const [selectedCommunityId, setSelectedCommunityIdState] = useState<
    string | null
  >(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("selectedCommunityId");
    }
    return null;
  });

  const setSelectedCommunityId = (id: string | null) => {
    setSelectedCommunityIdState(id);
    if (typeof window !== "undefined") {
      if (id) {
        localStorage.setItem("selectedCommunityId", id);
      } else {
        localStorage.removeItem("selectedCommunityId");
      }
    }
  };

  return (
    <CommunityContext.Provider
      value={{ selectedCommunityId, setSelectedCommunityId }}
    >
      {children}
    </CommunityContext.Provider>
  );
}

export function useCommunity() {
  const context = useContext(CommunityContext);
  if (context === undefined) {
    throw new Error("useCommunity must be used within a CommunityProvider");
  }
  return context;
}
